import { jsx as _jsx } from "react/jsx-runtime";
import { useCreateUserContext, userContext } from './Auth0UserProvider.context';
export const Auth0UserProvider = ({ permissions, usePermissions, loadingFallback = null, children, }) => {
    const permissionsResult = usePermissions();
    const context = useCreateUserContext({
        PERMISSIONS: permissions,
        permissions: permissionsResult.permissions,
    });
    if (permissionsResult.isLoading) {
        return loadingFallback;
    }
    return (_jsx(userContext.Provider, { value: context, children: typeof children == 'function' ? children(context) : children }));
};
